import { defineComponent, createElementBlock, openBlock, createVNode, createElementVNode } from "vue";
import _sfc_main$1 from "../components/FlowIcon.vue.js";
const _hoisted_1 = {
  class: "sidebar-search",
  type: "button"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FindAnythingButton",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", _hoisted_1, [
        createVNode(_sfc_main$1, {
          class: "search-icon",
          icon: "Search"
        }),
        _cache[0] || (_cache[0] = createElementVNode("span", {
          class: "sidebar-search-input",
          type: "text"
        }, " Find Anything ", -1))
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FindAnythingButton.vue2.js.map
